import { showStatus } from "@/services";
import { toast } from "react-toastify";

// Dicionário de tradução dos campos da atividade para exibição nos alertas em português
const fieldLabels: Record<string, string> = {
  completedDate: "Data realizada",
  sendDate: "Data enviada",
  idQualityAnalyst: "Analista de qualidade",
  quality: "Qualidade",
  security: "Segurança",
  idTeam: "Equipe",
  idOutsourced: "Terceirizado",
  idCustomer: "Cliente",
  idResponsible: "Responsável",
  idSite: "Site",
  externalCode: "Código externo",
  description: "Descrição",
  requestedDate: "Data de solicitação",
  plannedDate: "Data de planejamento",
  deadlineDate: "Prazo limite",
  customerApprovalDate: "Data de aprovação do cliente",
  internalPreparationDate: "Data de preparação interna",
  plannedStartDate: "Data de início planejado",
  actualStartDate: "Data de início real",
  bookSubmissionDate: "Data de envio do book",
  idStage: "Etapa",
  idService: "Serviço",
  idScope: "Escopo",
  valueOriginal: "Valor original",
  valueDiscount: "Desconto",
  valueIncrease: "Acréscimo",
};

/**
 * Valida se os campos obrigatórios configurados para o status atual estão preenchidos na atividade.
 * 
 * @param statusId ID do status da atividade
 * @param activityData Objeto da atividade com os valores atuais
 * @returns boolean indicando se a validação passou
 */
export const validateRequiredFields = async (
  statusId: string | number | null | undefined,
  activityData: any
): Promise<boolean> => {
  if (!statusId) return true;

  try {
    const response = await showStatus({ id: statusId });
    const status = response?.status;

    if (status && status.requiredFields && status.requiredFields.length > 0) {
      const missingFields: string[] = [];

      status.requiredFields.forEach((field: string) => {
        const val = activityData[field];
        let isMissing = false;

        // Validação robusta de nulos, vazios, arrays vazios e objetos de data inválidos (como do MUI DatePicker)
        if (val === null || val === undefined || val === "") {
          isMissing = true;
        } else if (Array.isArray(val) && val.length === 0) {
          isMissing = true;
        } else if (val instanceof Date && isNaN(val.getTime())) {
          isMissing = true;
        } else if (val && typeof val.isValid === "function" && !val.isValid()) {
          isMissing = true;
        }

        if (isMissing) {
          const label = fieldLabels[field] || field;
          missingFields.push(label);
        }
      });

      if (missingFields.length > 0) {
        if (missingFields.length === 1) {
          toast.error(`O campo "${missingFields[0]}" é obrigatório para o status selecionado.`);
        } else {
          toast.error(
            `Os seguintes campos são obrigatórios para o status selecionado: ${missingFields.join(", ")}.`
          );
        }
        return false;
      }
    }
  } catch (error) {
    console.error("Erro ao validar campos obrigatórios do status:", error);
  }
  return true;
};
